import axios from "axios";
import { store } from "../store/index";
import { selectAccessToken } from "../store/auth/selectors";
import toastr from "toastr";
import config from "../config/index";

const axiosInstance = axios.create({
  baseURL: config.apiURL,
  headers: { "Content-Type": "application/json" },
});

axiosInstance.interceptors.request.use((reqConfig) => {
  const token = selectAccessToken(store.getState());
  if (token) reqConfig.headers.Authorization = `Bearer ${token}`;

  // 🔑 Let the browser handle FormData boundaries
  if (reqConfig.data instanceof FormData) {
    delete reqConfig.headers["Content-Type"];
    return reqConfig;
  }

  // 🔑 Default to JSON only if it's a plain object
  if (
    reqConfig.data &&
    typeof reqConfig.data === "object" &&
    !(reqConfig.data instanceof Blob) &&
    !(reqConfig.data instanceof ArrayBuffer)
  ) {
    reqConfig.headers["Content-Type"] = "application/json";
  }

  return reqConfig;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.data?.message?.error) {
      const messages = error.response.data.message.error;
      if (Array.isArray(messages)) {
        messages.forEach((m) => toastr.error(m));
      } else {
        toastr.error(messages);
      }
    } else {
      toastr.error(error.message || "Unexpected error occurred");
    }

    return Promise.reject(error);
  }
);

// Export a single function
export const apiClient = async ({
  url,
  method = "GET",
  data,
  params,
  onUploadProgress,
}) => {
  const response = await axiosInstance.request({
    url,
    method,
    data,
    params,
    onUploadProgress,
  });
  return response.data;
};
